import { Pagination } from "swiper";

import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/pagination";

const Testimonials = () => {
  const data = [
    {
      avatar: `${window.location.origin}/images/client.png`,
      name: "Tina Aslani",
      review:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Et, itaque explicabo beatae eligendi voluptate eaque doloremque eum, necessitatibus at eius illo distinctio a cupiditate. Cumque quidem sunt earum doloribus in.",
    },
    {
      avatar: `${window.location.origin}/images/client.png`,
      name: "HAmid Raad",
      review:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Et, itaque explicabo beatae eligendi voluptate eaque doloremque eum, necessitatibus at eius illo distinctio a cupiditate. Cumque quidem sunt earum doloribus in.",
    },
    {
      avatar: `${window.location.origin}/images/client.png`,
      name: "Ali Maleki",
      review:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Et, itaque explicabo beatae eligendi voluptate eaque doloremque eum, necessitatibus at eius illo distinctio a cupiditate. Cumque quidem sunt earum doloribus in.",
    },
    {
      avatar: `${window.location.origin}/images/client.png`,
      name: "Darioush Hosseini",
      review:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Et, itaque explicabo beatae eligendi voluptate eaque doloremque eum, necessitatibus at eius illo distinctio a cupiditate. Cumque quidem sunt earum doloribus in.",
    },
  ];
  return (
    <section id="testimonial">
      <h5>Review from clients</h5>
      <h2>Testimonials</h2>

      <Swiper
        className="container testimonials_container"
        modules={[Pagination]}
        spaceBetween={40}
        slidesPerView={1}
        pagination={{ clickable: true }}
      >
        {data.map(({ avatar, name, review }, i) => (
          <SwiperSlide key={i} className="testimonial">
            <div className="client_avatar">
              <img src={avatar} alt="client Image" />
            </div>
            <h5 className="client_name ">{name}</h5>
            <small className="client_review">{review}</small>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default Testimonials;
